import React, {useEffect} from "react";
import { Stack, Typography } from '@mui/material'
import { Person, Phone } from '@mui/icons-material'
import { useTheme } from '@mui/material/styles';

export default function CostumerInfo({ name, phone }){
    const theme = useTheme();
    return(
        <Stack
          direction='row'
          spacing={1}
          alignItems='center'
          justifyContent='center'
          border={'2px solid '+ theme.palette.primary.main}
          borderRadius='16px'
          height='30px'
          padding='0 8px'
          width='35%'
        >
          <Typography 
            display='flex'
            alignItems='center'
            justifyContent='center'
            fontSize='14.5px' 
            fontWeight='700'
          >
            <Person 
              sx={{ 
                color: theme.palette.primary.main,
                fontSize: '21px'
              }} 
            />
            {name}
          </Typography>
          {!['', null].includes(phone) && <>
              <Typography
                fontSize='14.5px'
                fontWeight='700'
              >
                -
              </Typography>

              <Typography
                display='flex'
                alignItems='center'
                justifyContent='center'
                fontSize='14.5px' 
                fontWeight='700'
              >
                <Phone 
                  sx={{ 
                    color: theme.palette.primary.main,
                    fontSize: '21px' 
                  }} 
                />
                {phone}
              </Typography>
            </>
          }
        </Stack>
    )
}